import {FC, memo} from "react";
import {useTranslation} from "react-i18next";

const NotFound: FC<{
  page?: string;
  message?: string;
  redirect?: string;
}> = ({page, message, redirect}) => {
  const {t} = useTranslation();
  return (
    <div className="text-neutral-black mx-auto flex h-[60vh] max-w-[850px] flex-col items-start justify-center gap-2 px-10">
      <span className="text-4xl font-medium">{t("404 Not Found")}</span>
      <span className="text-lg font-medium">
        {message ?? t("This page doesn't exist, have you mistyped something?")}
      </span>
      <a href={redirect ?? "/"} className="text-lg">
        {t("Return to")} {page ?? t("homepage")}
      </a>
    </div>
  );
};

export default memo(NotFound);
